import React, { Fragment } from "react";
import T from "prop-types";
import { Field } from "redux-form";
import {
  FormRow,
  Select,
  CurrencyField,
  FormInput
} from "MODULES/shared/components/Forms";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import { Col } from "react-bootstrap";
import { INVENTORIES } from "MODULES/inventories/constants";
import { toOptions } from "LIB/forms";

export default function PriceDetails({
  disabledCondition,
  disabledPrice,
  exchangeSale: { input: { value = false } },
  commissionPaid
}) {
  /* eslint-disable no-unused-vars */
  const { scrap, parts_unit, ...filteredConditions } = INVENTORIES.condition;
  /* eslint-enable no-unused-vars */
  return (
    <Fragment>
      <FormRow>
        <Col md={6}>
          <Field
            name="condition"
            component={Select}
            label="Condition"
            options={toOptions(filteredConditions)}
            required
            disabled={disabledCondition}
          />
        </Col>
        <Col md={6}>
          <Field
            name="lead_time"
            component={FormInput}
            label="Days Lead Time"
            disabled={disabledPrice}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={6}>
          {!value && (
            <CurrencyField
              name="price_per_unit"
              label="Sales Ea."
              required
              disabled={disabledPrice || commissionPaid}
            />
          )}
        </Col>
      </FormRow>
    </Fragment>
  );
}

PriceDetails.propTypes = {
  disabledCondition: T.bool,
  disabledPrice: T.bool,
  exchangeSale: F.formField(F.boolInput),
  commissionPaid: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/PartDetails/PriceDetails.jsx